import React from 'react';
import classNames from 'classnames';
import Link from '../Link';
import InlineSvg from '../InlineSvg';

const RelatedContentCard = (props) => {
  const { resource, number, sliderRef } = props;
  const { pageExcerpt, title, category, featuredImage, link } = resource || {};
  const reference = resource?.reference || {};
  const { referencedTitle, shortExcerpt } = reference || {};
  const excerpt = shortExcerpt || pageExcerpt?.excerpt || '';
  const landscapeImage = reference.landscapeImage || featuredImage?.node;
  const landscapeRetinaImage = reference.landscapeRetinaImage || '';

  const cardVariations = [
    'related-content-card__variant1Card',
    'related-content-card__variant2Card',
    'related-content-card__variant3Card',
    'related-content-card__variant4Card',
    'related-content-card__variant5Card',
  ];

  const selectedVariation = number % cardVariations.length;

  const displayTitle = referencedTitle ? referencedTitle : title;

  return (
    <div
    onFocus={
      () => {
        sliderRef?.current?.slickGoTo(number)
      }
    }
    className="related-content-card__outer">
      <Link to={link} className="related-content-card__linkWrapper">
        <div
          className={classNames(
            'related-content-card__root',
            cardVariations[selectedVariation]
          )}
        >
          <div className="related-content-card__contentWrapper">
            {category ? (
              <span className="related-content-card__category">{category}</span>
            ) : null}
            <h3 className="related-content-card__heading">
              {displayTitle}
            </h3>
            <p className="related-content-card__shortExcerpt">{excerpt}</p>
            <span className="related-content-card__bottomLink">
              <InlineSvg
                name="arrow"
                className="related-content-card__linkArrow"
              />
            </span>
          </div>
          {landscapeImage?.sourceUrl ? (
            <div className="related-content-card__landscapeImageWrapper">
              <img
                className="related-content-card__landscapeImage"
                src={landscapeImage.sourceUrl}
                alt={referencedTitle}
                srcSet={`${landscapeImage.sourceUrl} ${landscapeRetinaImage.sourceUrl != '' ? ',' + landscapeRetinaImage.sourceUrl + '2x' : ""}`}
              />
            </div>
          ) : null}
        </div>
      </Link>
    </div>
  );
};

export default RelatedContentCard;
